import { Facebook, Instagram, MessageCircle, Mail, Heart } from "lucide-react";
import { useLang } from "@/i18n";
import { SectionHead, Reveal, WaveDivider } from "@/components/Widgets";

export default function About() {
  const { t } = useLang();
  return (
    <div data-testid="about-page">
      <section className="relative h-[42vh] min-h-[320px] overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1516483638261-f4dbaf036963?auto=format&fit=crop&w=1600&q=80"
          alt="Maremma"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-black/10" />
        <div className="absolute bottom-0 inset-x-0 max-w-7xl mx-auto px-4 sm:px-6 pb-10">
          <h1 className="font-heading font-bold text-4xl sm:text-5xl text-calce text-shadow-hero">{t("about.title")}</h1>
        </div>
        <div className="absolute bottom-[-1px] inset-x-0"><WaveDivider fill="#FBFAF6" /></div>
      </section>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
        {[t("about.p1"), t("about.p2"), t("about.p3")].map((p, i) => (
          <Reveal key={i} delay={i * 0.06}>
            <p className={`text-base sm:text-lg leading-relaxed text-grafite/80 ${i > 0 ? "mt-6" : ""} ${i === 1 ? "font-accent text-2xl text-mare" : ""}`}>{p}</p>
          </Reveal>
        ))}

        <Reveal className="mt-12">
          <div className="bg-white rounded-3xl p-8 shadow-[0_8px_30px_rgb(14,110,140,0.08)]">
            <h2 className="text-xs tracking-[0.2em] uppercase font-bold text-terracotta mb-5">{t("about.contact")}</h2>
            <a href="mailto:info@likefollonica.it" data-testid="about-email"
              className="inline-flex items-center gap-3 rounded-full bg-mare hover:bg-[#0b5a73] text-white font-bold px-6 py-3.5 transition-colors">
              <Mail className="w-4 h-4" /> info@likefollonica.it
            </a>
            <h2 className="text-xs tracking-[0.2em] uppercase font-bold text-terracotta mt-8 mb-4">{t("about.social")}</h2>
            <div className="flex gap-3">
              <a href="https://facebook.com" target="_blank" rel="noreferrer" data-testid="about-facebook" aria-label="Facebook"
                className="w-11 h-11 rounded-full bg-sabbia text-mare hover:bg-mare hover:text-white flex items-center justify-center transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noreferrer" data-testid="about-instagram" aria-label="Instagram"
                className="w-11 h-11 rounded-full bg-sabbia text-mare hover:bg-mare hover:text-white flex items-center justify-center transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://wa.me/390566260000" target="_blank" rel="noreferrer" data-testid="about-whatsapp" aria-label="WhatsApp"
                className="w-11 h-11 rounded-full bg-sabbia text-pineta hover:bg-pineta hover:text-white flex items-center justify-center transition-colors">
                <MessageCircle className="w-5 h-5" />
              </a>
            </div>
          </div>
        </Reveal>

        <Reveal className="mt-10 text-center">
          <p className="font-accent text-2xl text-grafite/50 inline-flex items-center gap-2">
            {t("footer.tag")} <Heart className="w-5 h-5 fill-terracotta text-terracotta" />
          </p>
        </Reveal>
      </div>
    </div>
  );
}
